import { MoveChildAccountsOptions } from 'types/dataFieldValue';

// Number format for currency/percentage display
export type NumberFormat = {
  comma?: boolean;
  currency_code?: string;
  places?: string;
  type?: string;
};

// Base column type for the grid
export type DataGridColumn = {
  id: string;
  title: string;
  type: 'text' | 'number' | 'dropdown' | 'boolean' | 'date' | 'badge';
  editable: boolean;
  formula?: string;
  variant: string;
  width: number | undefined;
  format?: NumberFormat | undefined;
};

export type TQGridColumn = DataGridColumn & {
  source?: string;
  isSchemaEditable: boolean;
  isSystem: boolean;
  order: number;
  isPinned: boolean;
  dataType: 'string' | 'picklist' | 'number' | 'date' | 'boolean';
  metadata?: {
    snapshot_column: {
      variant: string;
    };
  };
  themeOverride?: object;
  hasMenu?: boolean;
  enableCommitMode?: boolean;
};

export enum TQTabView {
  ACCOUNTS = 'accounts',
  TERRITORIES = 'territories',
}

export enum AccountsSystemColumns {
  TERRITORY_ASSIGNMENT = 'Territory Assignment',
}

export type CommitMetaData = {
  type: undefined | 'TerritoryAssignmentUpdate';
  moveAccountChildrenSelection?: MoveChildAccountsOptions;
  triggerPush: () => void;
  rejectCommits: () => void;
};
